import { jsxs as r, jsx as l } from "react/jsx-runtime";
const e = (o) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...o,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m13.39 11.122 1.13-4.857-1.8-.02-1.47-3.513-1.381.58 1.217 2.913-6.19-.07L6.244 3.28l-1.358-.636-1.635 3.492-1.725-.02 1.422 6.827 9.19.105-.383-1.505-7.585-.087-.796-3.819 9.264.106-.883 3.8 1.635-.421Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m12.636 7.742-9.264-.107.797 3.818 7.583.087.884-3.798Z"
        }
      )
    ]
  }
);
export {
  e as ShopFilled
};
